import { NgModule } from '@angular/core';

import { PanelsComponent } from './panels.component';
import { CommonModule } from '@angular/common';
import { PanelsService } from './panels.service';
import { DynamicModule } from '../dynamic/dynamic.module';

@NgModule({
  imports: [
    CommonModule,
    DynamicModule
  ],
  exports: [PanelsComponent],
  declarations: [PanelsComponent],
  providers: [PanelsService],
})
export class PanelsModule { }
